function Settings() {
  return <div>SETTINGS</div>;
}

export default Settings;
